import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = [...comics].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between mb-10">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            最新更新
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            实时同步，追更不等待
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {latest.map((comic) => {
          const cat = categories.find((c) => c.slug === comic.category);
          return (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 hover:shadow-md transition-all duration-300 group cursor-pointer"
            >
              <div className="w-20 md:w-24 flex-shrink-0">
                <div className="aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={comic.cover}
                    alt={`${comic.title} - 韩漫之家`}
                    title={`${comic.title} - 免费韩漫`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="flex-1 min-w-0 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                    {cat?.name || comic.category}
                  </span>
                  <span className={`text-[11px] px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                    comic.status === '连载中'
                      ? 'bg-primary-50 text-primary-600'
                      : 'bg-secondary-200 text-secondary-600'
                  }`}>
                    {comic.status}
                  </span>
                </div>

                <h3 className="text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                  {comic.title}
                </h3>

                <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {comic.description}
                </p>

                <div className="mt-2 flex items-center gap-4 flex-wrap">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-user-line text-[10px]"></i>
                    {comic.author}
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                    {comic.rating}
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line text-[10px]"></i>
                    {comic.updateDate}
                  </span>
                  <span className="text-xs text-primary-500 flex items-center gap-1">
                    <i className="ri-book-open-line text-[10px]"></i>
                    {comic.chapters.length}话
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}